import React from 'react';
import { useSelector } from 'react-redux';
import { PageTitle, PageBreadcrumbs, Container, SEOBlock, NotFound } from 'common/components';
import { ConfiguratorsListingSection, pageTitleStyles } from './styled';
import { AdditionalText, Benefits, ConfiguratorsList } from './components';
import { selectConfigurators, selectConfiguratorsNetwork } from './selectors';
import { UnavailableServicesBanner } from './components/unavailable-services-banner';
import { Bestsellers } from './components/bestsellers';

export const ConfiguratorsListing = () => {
	const configurators = useSelector(selectConfigurators);
	const { isFailed } = useSelector(selectConfiguratorsNetwork);

	const configuratorsIsVisible = !!configurators.length;
	const configuratorsIsAvailable = configurators.some(({ isAvailable }) => isAvailable);
	const isShowBanner =
		!configuratorsIsVisible || (configuratorsIsVisible && !configuratorsIsAvailable);

	if (isFailed) {
		return (
			<NotFound description="Произошла ошибка при&nbsp;загрузке данных. Обновите&nbsp;страницу&nbsp;или попробуйте позже" />
		);
	}

	return (
		<ConfiguratorsListingSection id="categories-listing">
			<Container>
				<Benefits />
				<PageBreadcrumbs />
				<PageTitle className={pageTitleStyles} />

				{isShowBanner && <UnavailableServicesBanner />}
				{configuratorsIsVisible && <ConfiguratorsList />}
				{!configuratorsIsAvailable && <Bestsellers />}
			</Container>
			<AdditionalText />
			<SEOBlock />
		</ConfiguratorsListingSection>
	);
};
